/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import axios from 'axios'
import router from '../router'

/*
|--------------------------------------------------------------------------
| Axios Base config
|--------------------------------------------------------------------------
|
*/
axios.defaults.baseURL = process.env.VUE_APP_BACKEND_URL

/*
|--------------------------------------------------------------------------
| Axios Request Interceptor
|--------------------------------------------------------------------------
|
*/
axios.interceptors.request.use(
    (config) => {
        config.headers['Accept'] = 'application/json'
        const tokenImpersonate = localStorage.getItem('token_impersonate')
        let token = localStorage.getItem('token')
        token = tokenImpersonate ?? token
        if (token) config.headers['Authorization'] = `Bearer ${token}`

        return config
    },

    (error) => {
        return Promise.reject(error)
    }
)

/*
|--------------------------------------------------------------------------
| Axios Response Interceptor
|--------------------------------------------------------------------------
|
*/
axios.interceptors.response.use(
    function (response) {
        return response
    },
    function (error) {
        const url = error.config ? error.config.url : ''
        const isAuthRequest = url.includes('/api/tokens') || url.includes('/oauth/token') || url.includes('/api/forgot-password')
        if (error.response && error.response.status === 401 && !isAuthRequest) {
            localStorage.removeItem('token')
            router.push('/').catch(() => {})
        }
        /*
         * Un 403 n'est plus une navigation.
         *
         * L'autorisation d'ouvrir un écran est portée par la garde du routeur
         * (`meta.permission` / `meta.anyPermission`) : c'est là qu'elle doit
         * être décidée, avant que quoi que ce soit ne soit chargé. Un refus du
         * serveur sur un appel est une erreur de données, à afficher là où elle
         * se produit — l'appelant la remonte via `dispatchError`.
         *
         * La règle inverse éjectait l'utilisateur d'un écran auquel il avait
         * droit dès qu'un appel secondaire était refusé : la recherche de la
         * barre du haut, le préchargement des paramètres de la commune, un
         * widget de tableau de bord. Un écran qui n'a rien à montrer sans un
         * appel précis peut toujours demander l'ancien comportement avec
         * `redirect403: true`.
         */
        if (
            error.response &&
            error.response.status === 403 &&
            !isAuthRequest &&
            error.config &&
            error.config.redirect403
        ) {
            router.push('/403').catch(() => {})
        }
        if (error.response && error.response.status === 404 && !isAuthRequest) {
            router.push('/404').catch(() => {})
        }
        return Promise.reject(error)
    }
)

export default axios
